<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="拦截状态"
                    @keyup.native.enter="search"
                  >
                    <el-option value="">全部</el-option>
                    <el-option
                      v-for="item in resData.options.status"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                      >{{ item.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.user_id"
                    placeholder="用户ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="实际拦截时间">
                  <el-date-picker
                    v-model="form.intercept_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                    @keyup.native.enter="search"
                  >
                  </el-date-picker>
                </el-form-item>
                <br />
                <el-form-item label="添加拦截时间">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                    @keyup.native.enter="search"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>包裹列表</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="showCreateDialog"
            >添加包裹拦截</el-button
          >
          <el-button type="primary" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData.list" style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="shipping_num"
              label="快递单号"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="user_id"
              label="用户id"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="intercept_time"
              label="实际拦截时间"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="intercept_admin_name"
              label="拦截人"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="as_packageintercept_status"
              label="拦截状态"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="create_admin_name"
              label="添加人"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="create_time"
              label="添加拦截时间"
            ></el-table-column>
            <el-table-column
              align="center"
              shiw-overflow-tooltip
              width="150"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status != 2"
                  type="danger"
                  size="mini"
                  @click="cancel(scope.row.id)"
                  >取消拦截</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.p"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.psize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="createInterceptPackageShow"
      width="30%"
      title="请输入拦截快递单号"
      :before-close="closeCreateDialog"
    >
      <el-form :model="createForm">
        <el-form-item label="">
          <el-input
            ref="shipping_num_input"
            v-model="checkForm.shipping_num"
            placeholder="快递单号"
            @keyup.native.enter="checkShippingNum"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-tag
            v-for="item in createForm.shipping_nums"
            :key="item"
            size="medium"
            closable
            @close="deleteShippingNum(item)"
            >{{ item }}</el-tag
          >
        </el-form-item>
        <el-form-item label="批量导入">
          <el-upload
            ref="upload"
            :action="action"
            name="excel"
            :limit="1"
            :on-success="importFile"
            :file-list="fileList"
            :auto-upload="true"
            with-credentials
          >
            <el-button slot="trigger" size="mini" type="primary">
              选择文件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateDialog">取 消</el-button>
        <el-button type="primary" @click="createIntercept">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "AsPackageIntercept",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      fileList: [],
      createInterceptPackageShow: false,
      loading: false,
      filterFold: false,
      tableLoading: false,
      createForm: {
        shipping_nums: [],
      },
      checkForm: {
        shipping_num: "",
      },
      form: {
        shipping_num: "",
        status: "",
        user_id: "",
        intercept_time: this.$excalibur.getDateTimeOnHours(1, 6),
        create_time: [],
        p: 1,
        psize: 50,
        is_excel: 0,
      },
      resData: {
        list: [],
        options: {
          status: [],
        },
      },
      action: `${apiBaseURL}/erp/AsPackageIntercept/importFile`,
    };
  },
  methods: {
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData() {
      this.$http
        .post("/erp/AsPackageIntercept/getList", this.form)
        .then((res) => {
          if (res.data.code === 200) {
            if (this.form.is_excel) {
              window.open(apiBaseURL + res.data.data.file);
            } else {
              this.resData = res.data.data;
            }
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    reset() {
      this.form = {
        shipping_num: "",
        status: "",
        user_id: "",
        intercept_time: this.$excalibur.getDateTimeOnHours(1, 6),
        create_time: [],
        p: 1,
        psize: 50,
        is_excel: 0,
      };
      this.fetchData();
    },
    search() {
      this.form.is_excel = 0;
      this.form.p = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.form.is_excel = 0;
      this.form.p = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.is_excel = 0;
      this.form.p = 1;
      this.form.psize = val;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.fetchData();
    },
    importFile(res) {
      if (res.code === 200) {
        window.open(apiBaseURL + res.data.file);
        this.fetchData();
        this.closeCreateDialog();
      } else {
        this.$message.e(res.msg);
      }
    },
    showCreateDialog() {
      this.createInterceptPackageShow = true;
      // dialog组件有一个show的过程 需要延迟获取焦点
      setTimeout(() => {
        this.$refs.shipping_num_input.focus();
      }, 500);
    },
    closeCreateDialog() {
      this.fileList = [];
      this.checkForm = {
        shipping_num: "",
      };
      this.createForm = {
        shipping_nums: [],
      };
      this.createInterceptPackageShow = false;
    },
    createIntercept() {
      if (this.createForm.shipping_nums.length <= 0) {
        this.$message.e("请输入要创建拦截的运单号");
        return;
      }
      this.$http
        .post("/erp/AsPackageIntercept/create", this.createForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.fetchData();
            this.closeCreateDialog();
            this.$message.success("添加成功");
          } else {
            this.$message.e(res.data.msg);
            this.$refs.shipping_num_input.focus();
          }
        });
    },
    cancel(id) {
      this.$http
        .post("/erp/AsPackageIntercept/cancel", {
          id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("取消成功");
            this.fetchData();
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    checkShippingNum() {
      this.$http
        .post("/erp/AsPackageIntercept/createCheck", {
          shipping_num: this.checkForm.shipping_num,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.createForm.shipping_nums.push(res.data.data.shipping_num);
            this.checkForm.shipping_num = "";
            this.$refs.shipping_num_input.focus();
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    deleteShippingNum(tag) {
      this.createForm.shipping_nums.splice(
        this.createForm.shipping_nums.indexOf(tag),
        1
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/aspackage/AsPackageIntercept.vue